import React from 'react';
import User from "./User";
import PropTypes from "prop-types";
import InvitedUser from "../../containers/Users/InvitedUser";

const UsersList = props => {
  let number = 1;
  const wareHouseAdmins = props.users.warehouseAdmins ?
      props.users.warehouseAdmins.map((user, index) => {
        number = index;
        return <User key={index} user={user}
                     index={number}
                     toggleActivation={props.toggleActivation}
                     openModal={props.openModal}/>
      }) : null;

  const companyUsers = props.users.company_users ? props.users.company_users.map(user => {
    number++;
    return <User key={number}
                 user={user}
                 index={number}
                 toggleActivation={props.toggleActivation}
                 openModal={props.openModal}/>
  }) : null;

  const invitedAdmins = props.users.invited_warehouse_admins ? props.users.invited_warehouse_admins.map(user => {
    number++;
    return <InvitedUser index={number + 1} key={number + 1} user={user}/>;
  }) : null;

  return (
      <table className="table table-bordered table-striped table-hover text-center main-table list-table user-table">
        <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">User name</th>
          <th scope="col">Email address</th>
          <th scope="col">User role</th>
          <th scope="col">Actions</th>
        </tr>
        </thead>
        <tbody>
        {wareHouseAdmins}
        {companyUsers}
        {invitedAdmins}
        </tbody>
      </table>
  );
};

UsersList.propTypes = {
  users: PropTypes.object,
  toggleActivation: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired
};

export default UsersList;



// WEBPACK FOOTER //
// ./src/components/UsersList/UsersList.jsx